import {useMemo} from 'react';
import {t} from '../../../common/getTranslations';
import {removeBlankInText} from '../../../common/removeBlankInText.funtion';
import {useDialog} from '../../../dialog/useDialog.hook';
import {Maybe, SortOption} from '../../../graphql/generated/types';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';

export function useCommentSortOptDialog({
  isMobile,
  productId,
  sortOptList,
  selectedSortOpt,
  onSelectSortOption,
}: {
  isMobile: boolean;
  productId?: number;
  sortOptList: Maybe<Array<Maybe<SortOption>>>;
  selectedSortOpt: Maybe<SortOption>;
  onSelectSortOption: (sortOptIndex: number) => void;
}) {
  const {DialogWrapper, Dialog, showDialog, hideDialog} = useDialog({
    isMobile,
  });

  const dialogElem = useMemo(() => {
    return (
      <DialogWrapper
        {...putTiaraObjectProps({
          customProps: {
            page_sort:
              !selectedSortOpt || !selectedSortOpt.name
                ? undefined
                : removeBlankInText(selectedSortOpt.name),
            ...(productId ? {event_episode_id: String(productId)} : {}),
          },
          click: {
            layer1: '필터정렬',
          },
        })}
      >
        <Dialog.Dimmed />
        <Dialog.List className="space-y-0">
          {sortOptList &&
            sortOptList.map((opt, index) => {
              if (!opt || !selectedSortOpt) return;
              return (
                <Dialog.Option
                  key={opt.id}
                  isChecked={opt.param === selectedSortOpt.param}
                  onClick={e =>
                    LOG_CLICK_EVENT('정렬_클릭', e, () => {
                      onSelectSortOption(index);
                      hideDialog();
                    })
                  }
                  {...putTiaraObjectProps({
                    click: {
                      copy: removeBlankInText(opt.name),
                    },
                  })}
                >
                  {opt.name}
                </Dialog.Option>
              );
            })}
        </Dialog.List>
        <Dialog.BottomCombination>
          <Dialog.Button onClick={hideDialog}>
            {t('common_cancel_button')}
          </Dialog.Button>
        </Dialog.BottomCombination>
      </DialogWrapper>
    );
  }, [
    Dialog,
    DialogWrapper,
    hideDialog,
    onSelectSortOption,
    productId,
    selectedSortOpt,
    sortOptList,
  ]);

  return {
    showDialog,
    hideDialog,
    commentSortOptDialog: dialogElem,
  };
}
